module.exports = __webpack_public_path__ + "7b7d827f7e4a8d163b312fea5e3eb631.fbx";